var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "block-container" }, [
      _c("div", { staticClass: "swb-back-row" }, [
        _vm.checkActionPerm("add_work_voucher") &&
        _vm.servcOrder != null &&
        !_vm.servcOrder.cancelled &&
        _vm.shopFlag &&
        _vm.comId == _vm.shopId
          ? _c("div", { staticClass: "btn-row bg-white" }, [
              _c(
                "div",
                { staticClass: "left-btn fl", on: { click: _vm.addWork } },
                [_vm._m(0)]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "orders-list-container" }, [
          _c(
            "table",
            { staticClass: "orders-list-panel1" },
            [
              _vm._m(2),
              _vm._v(" "),
              _vm._m(3),
              _vm._v(" "),
              _vm._l(_vm.servcWorkVoucherList, function(servcWorkVoucher) {
                return _c("tbody", { staticClass: "orders-body" }, [
                  _vm._m(4, true),
                  _vm._v(" "),
                  _c("tr", { staticClass: "abstract-row" }, [
                    _c("td", { attrs: { colspan: "7" } }, [
                      _c("div", { staticClass: "abstract-content" }, [
                        _c("span", { staticClass: "mr30" }, [
                          _vm._v(
                            "派工单号：\n                                    "
                          ),
                          _vm.checkActionPerm("to_work_voucher") && _vm.shopFlag
                            ? _c(
                                "a",
                                {
                                  staticClass: "swb-btn-link",
                                  on: {
                                    click: function($event) {
                                      _vm.toWorkVoucherPage(servcWorkVoucher.no)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(servcWorkVoucher.no))]
                              )
                            : _c("span", [_vm._v(_vm._s(servcWorkVoucher.no))])
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "mr30" }, [
                          _vm._v("买家公司名称："),
                          _c("a", [
                            _vm._v(_vm._s(servcWorkVoucher.buyerShopName))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "mr30" }, [
                          _vm._v("联系买家："),
                          _c("a", [
                            _vm._v(_vm._s(servcWorkVoucher.buyerShopContactTel))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "mr30" }, [
                          _vm._v("买家机构地址："),
                          _c("a", [
                            _vm._v(_vm._s(servcWorkVoucher.buyerShopAddr))
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      servcWorkVoucher.requestProxied
                        ? _c("div", { staticClass: "table-tips order" })
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", { staticClass: "info-row" }, [
                    _c("td", [
                      _c("div", { staticClass: "goods-info-block clearfix" }, [
                        _c("div", { staticClass: "good-img" }, [
                          _c("img", {
                            attrs: { src: servcWorkVoucher.servcFileBrowseUrl }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "good-msg" }, [
                          _c("p", { staticClass: "ellipsis-2 font12" }, [
                            _vm._v(_vm._s(servcWorkVoucher.servcTitle))
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("td", { staticStyle: { "text-align": "right" } }, [
                      _c("span", [
                        _vm._v(
                          _vm._s((servcWorkVoucher.amount || 0).toFixed(2))
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "align-left" }, [
                      servcWorkVoucher.servicerEngineer != null
                        ? _c("div", { staticClass: "clearfix" }, [
                            _c("div", { staticClass: "good-img" }, [
                              _c("img", {
                                attrs: {
                                  src:
                                    servcWorkVoucher.servicerEngineer
                                      .fileBrowseUrl
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("div", {}, [
                              _c("p", { staticClass: "ellipsis-2 font12" }, [
                                _vm._v(_vm._s(servcWorkVoucher.engineerName))
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "ellipsis-2 font12" }, [
                                _vm._v(
                                  _vm._s(
                                    servcWorkVoucher.servicerEngineer.contactTel
                                  )
                                )
                              ])
                            ])
                          ])
                        : _c("div", { staticClass: "clearfix" }, [
                            _c(
                              "p",
                              { staticClass: "font12 align-center font-red" },
                              [_vm._v("待指派工程师")]
                            )
                          ])
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "p",
                        [
                          servcWorkVoucher.beyondWrnt
                            ? _c("el-tag", { attrs: { type: "danger" } }, [
                                _vm._v("交易约定外")
                              ])
                            : _c("el-tag", { attrs: { type: "success" } }, [
                                _vm._v("交易约定内")
                              ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("p", { staticClass: "font-gray1" }, [
                        _vm._v(_vm._s(servcWorkVoucher.planTime))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      servcWorkVoucher.emgLevel == 0
                        ? _c("p", { staticClass: "font-green" }, [
                            _vm._v(
                              _vm._s(_vm.emgLevelMap[servcWorkVoucher.emgLevel])
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      servcWorkVoucher.emgLevel == 1
                        ? _c("p", { staticClass: "font-orange" }, [
                            _vm._v(
                              _vm._s(_vm.emgLevelMap[servcWorkVoucher.emgLevel])
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      servcWorkVoucher.emgLevel == 2
                        ? _c("p", { staticClass: "font-red" }, [
                            _vm._v(
                              _vm._s(_vm.emgLevelMap[servcWorkVoucher.emgLevel])
                            )
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      servcWorkVoucher.invalid
                        ? _c("p", { staticClass: "font-red" }, [
                            _vm._v("已作废")
                          ])
                        : servcWorkVoucher.closed
                        ? _c("p", { staticClass: "font-red" }, [
                            _vm._v("已关闭")
                          ])
                        : !servcWorkVoucher.invalid
                        ? _c("p", [_vm._v(_vm._s(servcWorkVoucher.stateText))])
                        : _vm._e(),
                      _vm._v(" "),
                      servcWorkVoucher.stateText == "服务暂停"
                        ? _c("p", { staticClass: "font-red" }, [
                            _vm._v(
                              "原因：" + _vm._s(servcWorkVoucher.stateDesc)
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      servcWorkVoucher.stateText == "已拒接"
                        ? _c("p", { staticClass: "font-red" }, [
                            _vm._v(
                              "拒接原因：" +
                                _vm._s(servcWorkVoucher.refuseCause)
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.checkActionPerm("view_charge_item")
                        ? _c(
                            "a",
                            {
                              staticClass: "swb-btn-link",
                              on: {
                                click: function($event) {
                                  _vm.toChargeItems(servcWorkVoucher.id)
                                }
                              }
                            },
                            [_vm._v("查看收费项")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "swb-btn-link",
                          on: {
                            click: function($event) {
                              _vm.toWorkVoucherDetail(servcWorkVoucher.id)
                            }
                          }
                        },
                        [_vm._v("查看详情")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      servcWorkVoucher.evalFlag
                        ? _c("p", { staticClass: "font-green" }, [
                            _vm._v("已评价")
                          ])
                        : _vm._e()
                    ])
                  ])
                ])
              })
            ],
            2
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "swb-btn swb-btn-small mr10" }, [
      _c("i", { staticClass: "icon iconfont icon-jiahao" }),
      _vm._v("新增派工单")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "order-search-container" }, [
      _c("a", { staticClass: "all-order" }, [_vm._v("全部派工单")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "350px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "80px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "220px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "180px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "60px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "200px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "108px" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "orders-header" }, [
      _c("tr", {}, [
        _c("th", [_vm._v("服务名称")]),
        _vm._v(" "),
        _c("th", [_vm._v("金额(元)")]),
        _vm._v(" "),
        _c("th", [_vm._v("主工程师")]),
        _vm._v(" "),
        _c("th", [_vm._v("预约上门时间")]),
        _vm._v(" "),
        _c("th", [_vm._v("紧急状态")]),
        _vm._v(" "),
        _c("th", [_vm._v("状态")]),
        _vm._v(" "),
        _c("th", [_vm._v("是否评价")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "blank-row" }, [
      _c("td", { attrs: { colspan: "7" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-729c0e94", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-729c0e94","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/workVoucher/ServcWorkVoucherOfOrder.vue
// module id = 1956
// module chunks = 1